<template>
  <base-message-page title="Questionario scaduto" message="Il periodo utile per la compilazione è terminato." />
</template>

<script>
import BaseMessagePage from '@/components/BaseMessagePage.vue'

export default {
  components: {
    BaseMessagePage,
  },
}
</script>
